import { useMemo } from 'react';
import { FiltersParams } from 'types/params';
import { useCurrentSearchState } from './useCurrentSearchState';

const useBuildQueryString = () => {
    const {
        bpmlowerbound,
        bpmupperbound,
        genres,
        instruments,
        keyquality,
        keyrootnote,
        orderby,
        orderbydirection,
        sfxs,
        tags,
        textsearch,
        type,
    } = useCurrentSearchState();

    const queryString = useMemo(() => {
        const searchParams = new URLSearchParams();

        // Params that could be duplicated
        genres?.forEach((genre) => {
            searchParams.append(FiltersParams.genres, genre);
        });
        instruments?.forEach((instrument) => {
            searchParams.append(FiltersParams.instruments, instrument);
        });
        sfxs?.forEach((sfx) => {
            searchParams.append(FiltersParams.sfxs, sfx);
        });
        tags?.forEach((tag) => {
            searchParams.append(FiltersParams.tags, tag);
        });

        // Params that are unique
        bpmlowerbound &&
            searchParams.set(FiltersParams.bpmlowerbound, bpmlowerbound);
        bpmupperbound &&
            searchParams.set(FiltersParams.bpmupperbound, bpmupperbound);
        keyquality && searchParams.set(FiltersParams.keyquality, keyquality);
        keyrootnote && searchParams.set(FiltersParams.keyrootnote, keyrootnote);
        orderby && searchParams.set(FiltersParams.orderby, orderby);
        orderbydirection &&
            searchParams.set(FiltersParams.orderbydirection, orderbydirection);
        textsearch &&
            searchParams.set(FiltersParams.textsearch, textsearch.join(','));
        type && searchParams.set(FiltersParams.type, type);

        return searchParams.toString();
    }, [
        bpmlowerbound,
        bpmupperbound,
        genres,
        instruments,
        keyquality,
        keyrootnote,
        orderby,
        orderbydirection,
        sfxs,
        tags,
        textsearch,
        type,
    ]);

    return queryString;
};

export default useBuildQueryString;
